// Centralização de chamadas à API sem fallback automático
const ENV_API = String(import.meta.env?.VITE_URL_API || '').trim();
const DEV_MODE = String(import.meta.env?.VITE_DEV_MODE || 'false').toLowerCase() === 'true';
const VITE_DEV = Boolean(import.meta.env?.DEV);
export const PROD_BASE = 'https://servicesapi.joviplanet.com';

const PRIVATE_HOST_REGEX = /^(localhost|127\.|10\.|192\.168\.|172\.(1[6-9]|2[0-9]|3[0-1]))/i;

const isPrivateNetworkUrl = (value) => {
  if (!value) return false;
  try {
    const url = new URL(value.startsWith('http') ? value : `http://${value}`);
    return PRIVATE_HOST_REGEX.test(url.hostname);
  } catch (_) {
    return false;
  }
};

const shouldForceProdBase = () => {
  if (typeof window === 'undefined') return false;
  // Se DEV_MODE estiver ativo, nunca forçar produção
  if (DEV_MODE) return false;
  const host = window.location?.hostname || '';
  const runningOnPublicHost = host && !PRIVATE_HOST_REGEX.test(host);
  return runningOnPublicHost && isPrivateNetworkUrl(ENV_API);
};

// Normaliza base removendo barras finais duplicadas
// Se VITE_URL_API não estiver definido, caímos para PROD_BASE para evitar 404 no front quando não há proxy configurado.
// Garante base sempre definida: se VITE_URL_API não existir, cai para PROD_BASE mesmo em DEV
const baseCandidate = shouldForceProdBase()
  ? PROD_BASE
  : (ENV_API || PROD_BASE);

export const API_BASE = (baseCandidate || PROD_BASE).replace(/\/+$/,'');

function toAbsolute(pathOrUrl) {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  // Evita '/api/api' quando API_BASE já termina com '/api' (com ou sem barra final) e o caminho também inicia com '/api'
  const base = API_BASE.replace(/\/+$/,'');
  let path = pathOrUrl.startsWith('/') ? pathOrUrl : '/' + pathOrUrl;
  if (/\/api$/i.test(base) && /^\/api(\/|$)/i.test(path)) {
    path = path.replace(/^\/api/i, '');
  }
  return `${base}${path}`;
}

export async function fetchWithFallback(pathOrUrl, options) {
  const url = toAbsolute(pathOrUrl);
  // Sem fallback: respeita estritamente API_BASE/ENV_API
  return fetch(url, options);
}

export async function fetchJson(pathOrUrl, options = {}) {
  const res = await fetchWithFallback(pathOrUrl, options);
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch (_) { /* ignora erro de JSON */ }
  return { res, data, raw: text };
}

export async function fetchAuth(pathOrUrl, options = {}) {
  const token = localStorage.getItem('auth_token');
  const headers = {
    'Accept': 'application/json',
    ...(options.headers || {}),
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else if (DEV_MODE) {
    // Log discreto apenas em dev para facilitar diagnóstico
    console.warn('[apiClient] Token ausente ao chamar fetchAuth para', pathOrUrl);
  }
  return fetchJson(pathOrUrl, { ...options, headers });
}
